<div
  #container
  [style.height.px]="calcContainerHeight ? wrapperHeight : null"
  [style.-webkit-line-clamp]="lineClamp"
  class="overflow-hidden relative z-10 text-{{ textAlignment }} bg-inherit overflow-ellipsis"
  [class.text-overflow]="isOverflown && isLeftAlignment"
>
  <ng-content></ng-content>
  @if (isOverflown && isJustifyAlignment) {
    <span class="absolute z-20 bottom-0 right-0 bg-inherit">...</span>
  }
</div>
